import { Component, Input, Output, EventEmitter, HostBinding, HostListener, ViewChild, ElementRef, AfterViewInit } from '@angular/core';
import { Key } from 'ts-keycode-enum';

@Component({
  selector: 'ng-hbm-bdi-editable-text',
  templateUrl: './editable-text.component.html'
})
export class EditableTextComponent implements AfterViewInit {


  private _preventBlurEvent:boolean;

  private _value:string;
  @Input() set value(value:string){
    this._value = value;
    if(this.editableDivRef){
      this.editableDivRef.nativeElement.innerHTML = this._value;
    }
  }

  private _multiline:boolean = false;
  @Input() set multiline(value:boolean){
    this._multiline = (value === true);
  }
  @Input() min:number;
  @Input() max:number;

  @Input() placeholder:string;

  @Output() onSubmit:EventEmitter<string> = new EventEmitter();

  @ViewChild('editableDivRef') editableDivRef; 


  showActionButtons:boolean;
  error:number;





  onKeypress(e:Event) {
    this._preventBlurEvent = false;
    // console.log("keypress");
    
  }

  disableContentEdition(){
    this.editableDivRef.nativeElement.setAttribute( 'contenteditable', false );
    this.showActionButtons = false;
    this._preventBlurEvent = false;
  }


  editableClickHandler(e:Event){
    if(this.editableDivRef.nativeElement.getAttribute( 'contenteditable' ) === 'false') {
      this.enableContentEdition();
    }
  }

  enableContentEdition(){
    this.editableDivRef.nativeElement.setAttribute( 'contenteditable', true );
    this.showActionButtons = true;
    if(this._multiline){
      if (!this.editableDivRef.nativeElement.lastChild || this.editableDivRef.nativeElement.lastChild.nodeName.toLowerCase() != "br") {
        this.editableDivRef.nativeElement.appendChild(document.createElement("br"));
      }
    }
    this.editableDivRef.nativeElement.focus();
  }




  onBlur(e:Event) {
    // console.log("onBlur", this._preventBlurEvent);

    if ( this._preventBlurEvent ){
      //Prevent blur
      e.preventDefault();
      e.stopImmediatePropagation();
    }
    else {
      //Cancel content modifications
      this.cancelEditableContent();
    }
  }

  onKeydownHandler(event: KeyboardEvent) {
    this.cleanEditableContent( event );
    this.checkEditableContentLength( event );
    this.checkEditableContentSecurity();
  }

  onKeyupHandler(event: KeyboardEvent) {
    if(this._multiline){
      if (!this.editableDivRef.nativeElement.lastChild || this.editableDivRef.nativeElement.lastChild.nodeName.toLowerCase() != "br") {
        this.editableDivRef.nativeElement.appendChild(document.createElement("br"));
      }
    }
    this.checkEditableContentSecurity();
  }



  constructor() { }

  ngAfterViewInit(): void {
    this.editableDivRef.nativeElement.innerHTML = this._value;
    this.checkEmpty();
  }

  validate(e): void {
    // console.log("validate");
    e.preventDefault();
    e.stopImmediatePropagation();
    this._preventBlurEvent = true;
    this.validateEditableContent();
    this.disableContentEdition();
  }

  cancel(e): void {
    this._preventBlurEvent = true;
    this.cancelEditableContent();
  }


  cancelEditableContent(): void {
    
    this.error = 0;
    this.editableDivRef.nativeElement.innerHTML = this._value;
    this.disableContentEdition();
    this.checkEmpty();
  }

  

  validateEditableContent(): void {

    this.error = 0;

    if(this.editableDivRef.nativeElement.textContent.match(/[<>"/&]/g) && this.editableDivRef.nativeElement.textContent.match(/[<>"/&]/g).length > 0){
      this.error = 1;
    } else if ( this.max && this.editableDivRef.nativeElement.textContent.length > this.max ) {
      this.error = 3;
    }else if( this.min && this.editableDivRef.nativeElement.textContent.length < this.min ) {
      this.error = 2;
    }

    if(this.error === 0){
      this.onSubmit.emit(this._multiline ? this.editableDivRef.nativeElement.innerHTML : this.editableDivRef.nativeElement.textContent);
    }

  }

  checkEmpty(){
    if ( this.editableDivRef.nativeElement.innerText.trim() === '' ){
      // console.log("empty");
      this.editableDivRef.nativeElement.innerHTML = '';
      this.editableDivRef.nativeElement.classList.add( 'empty' );
    } else {
      // console.log("!empty");
      this.editableDivRef.nativeElement.classList.remove( 'empty' );
    }
  }

  checkEditableContentSecurity () {

    this.checkEmpty();

    if(this.editableDivRef.nativeElement.textContent.match(/[<>"/&]/g) && this.editableDivRef.nativeElement.textContent.match(/[<>"/&]/g).length > 0){
      this.error = 1;
    }
    else{
      this.error = 0;
    }
  }


  checkEditableContentLength( event ) {

    if ( !this.max ){
      return;
    }

    // console.log("checkEditableContentLength()", event, this._multiline, (event.which === Key.Enter));

    if(!this._multiline && (event.which === Key.Enter)){
      // console.log("abort !");
      event.preventDefault();
      this.editableDivRef.nativeElement.textContent = this.editableDivRef.nativeElement.textContent.replace(/\n/g, "");
    }

    var allowedKeys = [
      Key.Backspace,
      Key.End,
      Key.Home,
      Key.LeftArrow,
      Key.UpArrow,
      Key.RightArrow,
      Key.DownArrow,
      Key.Delete
    ];

    if( allowedKeys.indexOf( event.which ) === -1 && this.editableDivRef.nativeElement.textContent.length >= this.max ){
      event.preventDefault();
    }
  }

  cleanEditableContent( event ) {
    // console.log("cleanEditableContent()", event);
    if ( event.which === Key.Enter ) {
      event.preventDefault();
      if (window.getSelection && this._multiline) {
        var selection = window.getSelection(),
            range = selection.getRangeAt(0),
            br = document.createElement("br");
        range.deleteContents();
        range.insertNode(br);
        range.setStartAfter(br);
        range.setEndAfter(br);
        range.collapse(false);
        selection.removeAllRanges();
        selection.addRange(range);
      }
      //document.execCommand( 'insertHTML', false, '<br><br>' );
      return false;
    }
    else{
      return true;
    }
  }


}
